import React, { Component } from "react";

import "./styles.css";

class ItemCreatorVerdadeiroFalso extends Component {
  render() {
    return (
      <input
        type="checkbox"
        disabled={this.props.readOnly}
        checked={this.props.checkStatus}
        onChange={() =>
          this.props.itemCheckChanger(
            this.props.itemIndex,
            !this.props.checkStatus
          )
        }
      />
    );
  }
}

export default ItemCreatorVerdadeiroFalso;
